import type { SavedFilter } from '@/types';

import { SavedFilterItem } from './SavedFilterItem';
import styles from './SavedFilters.module.scss';

interface SavedFiltersListProps {
  onApply: (savedFilter: SavedFilter) => void;
  onDelete: (savedFilter: SavedFilter) => void;
  onRename: (savedFilter: SavedFilter) => void;
  savedFilters: SavedFilter[];
}

export const SavedFiltersList = ({
  onApply,
  onDelete,
  onRename,
  savedFilters,
}: SavedFiltersListProps) => (
  <ul aria-label='Saved filters' className={styles.list}>
    {savedFilters.map((savedFilter) => (
      <SavedFilterItem
        key={savedFilter.id}
        onApply={onApply}
        onDelete={onDelete}
        onRename={onRename}
        savedFilter={savedFilter}
      />
    ))}
  </ul>
);
